"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = _interopRequireDefault(require("immutable"));

var _react = _interopRequireWildcard(require("react"));

var _GoodTile = _interopRequireDefault(require("marketplace-lib/components/goods/GoodTile"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _utils = require("../utils/utils");

var _GoodTileLink = _interopRequireDefault(require("./GoodTileLink"));

var GoodsGrid = function GoodsGrid(_ref) {
  var goods = _ref.goods,
      trackLinkClick = _ref.trackLinkClick;
  return _react.default.createElement(_UIGrid.default, {
    className: "directory-grid-margin-adjustment"
  }, goods.map(function (good) {
    var goodUrlToken = good.get('urlToken');

    var LinkRenderer = function LinkRenderer(props) {
      return _react.default.createElement(_GoodTileLink.default, (0, _extends2.default)({}, props, {
        goodUrlToken: goodUrlToken
      }));
    };

    var tileProps = {
      cardProps: {
        'data-test-id': 'good-tile'
      },
      goodImageUrl: good.get('marketingImageSmallUrl'),
      goodName: good.get('name'),
      goodPrice: good.get('price'),
      goodSubType: good.get('subType'),
      goodType: good.get('type'),
      goodUrlToken: goodUrlToken,
      isFree: good.get('free'),
      linkRenderer: LinkRenderer,
      onClick: function onClick() {
        return trackLinkClick('good-tile');
      },
      reviewInfo: good.get('reviewInfo')
    };

    if ((0, _utils.isCustomModule)(good)) {
      tileProps = (0, _extends2.default)({}, tileProps, {
        moduleCompatibility: good.get('moduleCompatibilities').toArray(),
        moduleSummary: good.get('marketingSummary')
      });
    } else if ((0, _utils.isTemplatePack)(good)) {
      tileProps = (0, _extends2.default)({}, tileProps, {
        packCounts: good.get('packCounts')
      });
    }

    return _react.default.createElement(_UIGridItem.default, {
      className: "directory-grid-tile-container",
      size: {
        md: 6,
        lg: 4,
        xl: 3
      },
      key: good.get('goodId') + good.get('name')
    }, _react.default.createElement(_GoodTile.default, tileProps));
  }));
};

GoodsGrid.propTypes = {
  goods: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  trackLinkClick: _react.PropTypes.func.isRequired
};
var _default = GoodsGrid;
exports.default = _default;
module.exports = exports.default;